var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushPin(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m648.696-462.696 86 77v79.783H519.609v239.305L480-27l-39.609-39.61v-239.304H225.869v-79.783l80-77v-321.261h-50v-79.218h442.827v79.218h-50v321.261Zm-315.261 77h287.13l-51.652-47.652v-350.609H385.087v350.609l-51.652 47.652Zm143.565 0Z"
  })));
}
export default SvgPushPin;